<div class="myPurchase-dialog-container">
    <div class="myPurchase-dialog-header">
        {{action}} task </div>
    <div class="myPurchase-dialog-content">
        <p *ngIf="action=='Transfer'">Once you transfer the item no. you have been tasked to do tagging, you will no
            longer
            be able to do tagging for that item no.</p>
        <p *ngIf="action=='Takeover'">Depending on the purchasing executive and material subgroup you choose to
            takeover
            from, that personnel will lose their current item-vendor tagging progress and access to the material
            subgroups
            they was assigned to.</p>
        <p>This action cannot be undone.</p>
        <mat-form [form]="peForm">
            <mat-form-field style="width: 80%!important; padding-top: 10px; padding-bottom: 10px;">
                <mat-label>Purchasing executive</mat-label>
                <mat-select [formControl]="getPurchasingExecutiveFormControl()" required>
                    <mat-option *ngFor="let pe of peArray" [value]="pe">{{getNameOfUser(pe)}}</mat-option>
                </mat-select>
                <mat-hint *ngIf="action=='Transfer'">The personnel you wish to transfer your task to.</mat-hint>
                <mat-hint *ngIf="action=='Takeover'">The personnel you wish to takeover your task from.</mat-hint>
            </mat-form-field>
            <mat-form-field style="width: 80%!important; padding-top: 10px; padding-bottom: 10px;">
                <mat-label>Item List</mat-label>
                <mat-select [formControl]="getItemListFormControl()" required multiple="true">
                    <mat-option *ngFor="let item of itemArray"
                        [value]="item">{{displayFrontendItemDescription(item)}}</mat-option>
                </mat-select>
                <mat-hint *ngIf="action=='Transfer'">Your assigned list of items to do tagging.</mat-hint>
                <mat-hint *ngIf="action=='Takeover'">The selected personnel's assigned list of item no. to do
                    tagging.</mat-hint>
            </mat-form-field>
        </mat-form>
    </div>
    <div class="myPurchase-dialog-actions">
        <div mat-dialog-actions>
            <app-button class="padBtn" name="Cancel" mat-dialog-close></app-button>
            <app-button class="padBtn actionBtn" type="flat-button" name="Save" (click)="onSubmit()"></app-button>
        </div>
    </div>
</div>